import { createReducer, on } from '@ngrx/store';
import { IDigitalProduct } from '../../digitalProduct/models/digitalProduct.model';
import { subscriptionActions } from './subscription.actions';
import { SubscriptionState } from './subscription.state';

export const initialSubscriptionState: SubscriptionState = {
    currentSubscription: {} as IDigitalProduct,
    subscriptionList: [] as IDigitalProduct[]
};

export const subscriptionReducer = createReducer(
    initialSubscriptionState,

    on(subscriptionActions.getSubscriptionsSuccess, (state, { subscriptionList }) => ({
        ...state,
        subscriptionList
    })),

    on(subscriptionActions.getSubscriptionSuccess, (state, { subscription }) => ({
        ...state,
        currentSubscription: subscription
    }))
);
